"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamChooser = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useTeamCreate_1 = __importDefault(require("@opsbase/react-gql-hooks/team/useTeamCreate"));
const react_1 = __importStar(require("react"));
const DataChooser_1 = __importDefault(require("../DataChooser"));
const makeDataChooser_1 = __importDefault(require("../helpers/makeDataChooser"));
exports.TeamChooser = (0, makeDataChooser_1.default)((props) => {
    const { value, canCreate } = props, otherProps = __rest(props, ["value", "canCreate"]);
    const createTeam = (0, useTeamCreate_1.default)();
    const self = (0, useSelf_1.default)();
    const canManageAllTeams = self.isPrimary || self.accessibleTeams.all;
    const valuesWithType = value === null || value === void 0 ? void 0 : value.map(s => (Object.assign(Object.assign({}, s), { type: DataType_1.default.TEAM })));
    const handleAddTeam = (0, react_1.useCallback)(name => createTeam({ patch: { title: name } }), [createTeam]);
    return (react_1.default.createElement(DataChooser_1.default, Object.assign({}, otherProps, { type: [DataType_1.default.TEAM], value: valuesWithType, selectLabel: lib_i18n_1.default.t('select-team'), addLabel: lib_i18n_1.default.t('create-a-team'), allSelectedLabel: lib_i18n_1.default.t('all-teams'), onAddNew: canCreate && canManageAllTeams ? handleAddTeam : undefined })));
});
exports.default = exports.TeamChooser;
